var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94726 0.227827C5.18458 0.465143 5.2429 0.827918 5.09194 1.12766C4.6983 1.90922 4.47627 2.79251 4.47627 3.7299C4.47627 6.92974 7.07026 9.52373 10.2701 9.52373C11.2075 9.52373 12.0908 9.3017 12.8723 8.90807C13.1721 8.7571 13.5349 8.81542 13.7722 9.05274C14.0095 9.29006 14.0678 9.65283 13.9168 9.95257C12.7086 12.3516 10.2222 14 7.34939 14C3.29043 14 0 10.7096 0 6.65061C0 3.77782 1.64842 1.29143 4.04743 0.083153C4.34717 -0.0678156 4.70995 -0.00948929 4.94726 0.227827ZM2.97243 2.85414C2.0894 3.87133 1.55555 5.19891 1.55555 6.65061C1.55555 9.85046 4.14954 12.4444 7.34939 12.4444C8.80109 12.4444 10.1287 11.9106 11.1459 11.0276C10.8586 11.0617 10.5663 11.0793 10.2701 11.0793C6.21115 11.0793 2.92072 7.78885 2.92072 3.7299C2.92072 3.43368 2.93828 3.14142 2.97243 2.85414Z",
    fill: "#6E6E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.9ec983fbcdc65cae322884d1dc1a00db.svg";
export { ForwardRef as ReactComponent };